import { string } from "prop-types";

export class AutoLoginTokenSubmit {
  visitorId: string | null | undefined;

  email: string | null | undefined;

  orderId: string | null | undefined;
}
